<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading py-1">
      <div class="col-12 d-flex align-items-center justify-content-between py-0">
        <h2 class="my-0 py-0">Manage Study Protocol</h2>
        <div class="d-flex align-items-center">
          <button
           v-if="protocol.status !== 'Generated'"
            class="save_btn py-1 px-4 mr-2"
            type="button"
            @click="createStudy()"
            :disabled="showLoading"
          >
            <div class="d-flex align-items-center">
              <img
                v-if="showLoading"
                class="loading-img me-2"
                width="20"
                src="../../../assets/img/loading.webp"
                alt="Wait while the document is added"
              />
              <span>{{ $t("navigations.create study") }}</span>
            </div>
          </button>
          <span class="cursor-pointer tooltip-wrapper pointer">
            <i class="fa fa-times close" @click="onclosed()"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </span>
        </div>
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="tabs-container col-md-12 px-0">
        <ul class="nav nav-tabs col-lg-12 mb-0" role="tablist">
          <li v-for="tab in tabs" :key="tab.id">
            <a
              href="#"
              class="nav-link"
              :class="{ activeTab: selectedTab === tab.id }"
              @click.prevent="selectTab(tab.id)"
            >
              {{ $t(tab.label) }}
            </a>
          </li>
        </ul>
      </div>
      <div class="row"></div>
      <div class="col-lg-12 px-0">
        <component :is="currentComponent"></component>
      </div>
    </div>
  </div>
</template>
<style scoped>
.activeTab {
  color: #495057;
  background-color: #fff !important;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .nav-link {
    margin-bottom: 0px;
    background: 0 0;
    border: 1px solid #e7eaec;
    padding: 2px 15px;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>
<script src="./StudyProtocolMng.js"></script>